import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import { Button, Popconfirm } from 'antd';

export function BtnBlockSum(props){
  const text = "Save these summaries?"

  function confirm(e){
    props.onClick();
  }

  return(
    <Popconfirm placement="top" title={text} onConfirm={confirm} okText="Yes" cancelText="No">
      <Button
        id="btn-block-summaries"
        icon="save"
        disabled = {props.disabled()}
        style={props.style}
        >Save
      </Button>
    </Popconfirm>
  )
}



// WEBPACK FOOTER //
// ./src/components/Buttons/BtnBlockSum.js